import {Injectable} from '@angular/core';

@Injectable()
export class DanamonStorage {

    public inquiryResult: any;
    public paymentResult: any;
    public imagePath: string;
    public moduleName: string;

    public constructor() {
    }
}
